import { useState } from "react";
import Input from "../../FormComponents/Input";

const PreFilterJoinedBy = ({ prefiltersJoinedBy, setPrefiltersJoinedBy }) => {
  const [errorLabel, setErrorLabel] = useState(false);
  const [inputState, setInputState] = useState(prefiltersJoinedBy);

  const handlePrefilterJoined = (e) => {
    const input = e.target.value.trim();

    setInputState(input);
    if (!checkParentheses(input)) {
      setErrorLabel(true);
    } else {
      setErrorLabel(false);
      setPrefiltersJoinedBy(input);
    }
  };
  const checkParentheses = (input) => {
    const stack = [];
    if (input.length === 0) return true;
    if (input[0] !== "(" || input[input.length - 1] !== ")") {
      return false;
    }
    for (const char of input) {
      if (char === "(") {
        stack.push(char);
      } else if (char === ")") {
        if (stack.pop() !== "(") {
          return false; // Unbalanced parentheses
        }
      }
    }
    return stack.length === 0; // Check if all parentheses are closed
  };

  return (
    <div className="builder_form mb_2" style={{ width: "200px" }}>
      <div>
        <Input
          label="Formula"
          type="text"
          value={inputState}
          onChange={(e) => handlePrefilterJoined(e)}
          placeholder="ex: A-Z ( ) | &" //A-Z ( ) | &
          error={errorLabel && "incorrect format"}
        />
      </div>
    </div>
  );
};

export default PreFilterJoinedBy;
